import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import * as paths from 'Paths';
import constants from 'Constants';


const EmailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/emails" */
    'routes/Emails/EmailsRoute'
  )
));

const UpdateEmailRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/update-email" */
    'routes/Emails/UpdateEmailRoute'
  )
));

const TemplatesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/templates" */
    'routes/Emails/TemplatesRoute'
  )
));

const AnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/analytics" */
    'routes/Emails/AnalyticsRoute'
  )
));

const RecipientsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/recipients" */
    'routes/Emails/RecipientsRoute'
  )
));

const ConversionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/conversions" */
    'routes/Emails/ConversionsRoute'
  )
));

const TagsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/tags" */
    'routes/Emails/TagsRoute'
  )
));

const BroadcastsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/broadcasts" */
    'routes/Emails/BroadcastsRoute'
  )
));

const DomainsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/domains" */
    'routes/Emails/DomainsRoute'
  )
));

const DomainDnsRecordsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/domain-dns-records" */
    'routes/Emails/DomainDnsRecordsRoute'
  )
));

const ProfilesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/profiles" */
    'routes/Emails/ProfilesRoute'
  )
));

const UpdateProfileRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/update-profile" */
    'routes/Emails/UpdateProfileRoute'
  )
));

const ProfileCompleteVerifyRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/profile-complete-verify" */
    'routes/Emails/ProfileCompleteVerifyRoute'
  )
));

const SettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/settings" */
    'routes/Emails/SettingsRoute'
  )
));


const EditSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/edit-settings" */
    'routes/Emails/EditSettingsRoute'
  )
));
const EditPreferencesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/edit-preferences" */
    'routes/Emails/EditPreferencesRoute'
  )
));

const SendingRulesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/sending-rules" */
    'routes/Emails/SendingRulesRoute'
  )
));

const EditSendingRulesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/edit-sending-rules" */
    'routes/Emails/EditSendingRulesRoute'
  )
));

const DeliveryStatsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/delivery-stats" */
    'routes/Emails/DeliveryStatsRoute'
  )
));

const SmtpProfilesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/smtp-profiles" */
    'routes/Emails/SmtpProfilesRoute'
  )
));

const SmtpProfileDnsRecordsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/smtp-profile-dns-records" */
    'routes/Emails/SmtpProfileDnsRecordsRoute'
  )
));

const UpdateSmtpProfileRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/emails/update-smtp-profile" */
    'routes/Emails/UpdateSmtpProfileRoute'
  )
));


const getEmailsRoutes = () => {
  return [
    {path: paths.getPathEmails(), render: (props) => <EmailsRoute {...props} kind={constants.EMAIL_KIND_BROADCAST} />},
    {path: paths.getPathBroadcastEmails(), render: (props) => <EmailsRoute {...props} kind={constants.EMAIL_KIND_BROADCAST} />},
    {path: paths.getPathWorkflowEmails(), render: (props) => <EmailsRoute {...props} kind={constants.EMAIL_KIND_WORKFLOW} />},
    {path: paths.getPathAddEmail(), component: UpdateEmailRoute},
    {path: paths.getPathEditEmail(":emailId"), component: UpdateEmailRoute},
    {path: paths.getPathReplicateEmail(":emailId"), render: (props) => <UpdateEmailRoute {...props} isReplicate={true} />},

    {path: paths.getPathAddEmailTemplate(), render: (props) => <UpdateEmailRoute {...props} isTemplate={true} templateType={constants.EMAIL_TEMPLATE_TYPE_CUSTOM} />},
    {path: paths.getPathEditEmailTemplate(":templateId"), render: (props) => <UpdateEmailRoute {...props} isTemplate={true} templateType={constants.EMAIL_TEMPLATE_TYPE_CUSTOM} />},

    {path: paths.getPathReplicateEmailTemplate(":templateId"), render: (props) => <UpdateEmailRoute {...props} isReplicate={true} isTemplate={true} templateType={constants.EMAIL_TEMPLATE_TYPE_CUSTOM} />},

    {path: paths.getPathLibraryEmailTemplates(), render: (props) => <TemplatesRoute {...props} type={constants.EMAIL_TEMPLATE_TYPE_LIBRARY} />},
    {path: paths.getPathCustomEmailTemplates(), render: (props) => <TemplatesRoute {...props} type={constants.EMAIL_TEMPLATE_TYPE_CUSTOM} />},

    {path: paths.getPathEmailAnalytics(":emailId"), component: AnalyticsRoute},
    {path: paths.getPathEmailRecipients(":emailId"), component: RecipientsRoute},
    {path: paths.getPathEmailConversions(":emailId"), component: ConversionsRoute},
    {path: paths.getPathEmailTags(), component: TagsRoute},

    {path: paths.getPathBroadcasts(), component: BroadcastsRoute},
    {path: paths.getPathEmailDomains(), component: DomainsRoute},
    {path: paths.getPathEmailDomainDnsRecords(":domainId"), component: DomainDnsRecordsRoute},

    {path: paths.getPathAddEmailProfile(), component: UpdateProfileRoute},
    {path: paths.getPathEditEmailProfile(":profileId"), component: UpdateProfileRoute},
    {path: paths.getPathEmailProfiles(), component: ProfilesRoute},
    {path: paths.getPathEmailProfileCompleteVerify(), component: ProfileCompleteVerifyRoute},

    {path: paths.getPathEmailSettings(), component: SettingsRoute},
    {path: paths.getPathEditEmailSettings(), component: EditSettingsRoute},
    {path: paths.getPathEditEmailPreferences(), component: EditPreferencesRoute},
    {path: paths.getPathEmailSendingRules(), component: SendingRulesRoute},
    {path: paths.getPathEditEmailSendingRules(), component: EditSendingRulesRoute},
    {path: paths.getPathEmailDeliveryStats(), component: DeliveryStatsRoute},

    {path: paths.getPathSmtpProfiles(), component: SmtpProfilesRoute},
    {path: paths.getPathAddSmtpProfile(), component: UpdateSmtpProfileRoute},
    {path: paths.getPathPreviewSmtpProfile(":profileId"), render: (props) => <UpdateSmtpProfileRoute {...props} isPreview={true} />},
    {path: paths.getPathSmtpProfileDnsRecords(":profileId"), component: SmtpProfileDnsRecordsRoute},
  ]
}



export { getEmailsRoutes };
